/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-content{border-radius:8px}.header[_ngcontent-%COMP%]{color:#444;padding:32px 48px}.header[_ngcontent-%COMP%]   .date[_ngcontent-%COMP%], .header[_ngcontent-%COMP%]   .subtitle[_ngcontent-%COMP%]{font-family:Inter,Arial,Helvetica,sans-serif}.header[_ngcontent-%COMP%]   .date[_ngcontent-%COMP%]{color:#999}.content[_ngcontent-%COMP%]{padding:60px 48px;background-color:#edf6ff;border-radius:8px}.content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{white-space:pre-wrap;margin-bottom:60px}"];
export { styles as styles };
//# sourceMappingURL=private-class-feedback-modal.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-feedback-modal/private-class-feedback-modal.component.scss.shim.ngstyle.js
// module id = 1277
// module chunks = 26 27 28